import { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { useAuth } from '@/context/AuthContext';
import axios from 'axios';

const AIContext = createContext({ aiEnabled: true, leadsEnabled: true, aiStatusLoading: true, refreshAIStatus: () => {} });

export const useAI = () => useContext(AIContext);

export function AIProvider({ children }) {
  const { token } = useAuth();
  const [aiEnabled, setAiEnabled] = useState(true);
  const [leadsEnabled, setLeadsEnabled] = useState(true);
  const [aiStatusLoading, setAiStatusLoading] = useState(true);

  const refreshAIStatus = useCallback(async () => {
    if (!token) {
      setAiStatusLoading(false);
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/org-settings/ai-status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAiEnabled(res.data.ai_enabled !== false);
      setLeadsEnabled(res.data.leads_enabled !== false);
    } catch {
      setAiEnabled(true);
      setLeadsEnabled(true);
    } finally {
      setAiStatusLoading(false);
    }
  }, [token]);

  useEffect(() => {
    refreshAIStatus();
    // Refresh every 10 minutes — ai/leads status rarely changes
    const interval = setInterval(refreshAIStatus, 600000);
    return () => clearInterval(interval);
  }, [refreshAIStatus]);

  return (
    <AIContext.Provider value={{ aiEnabled, leadsEnabled, aiStatusLoading, refreshAIStatus }}>
      {children}
    </AIContext.Provider>
  );
}
